import { DEBUG } from '@src/DEBUG';
DEBUG.open ( '/service/file-manager.ts' );

import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material';
import {Constants} from '../commons/Constants';
import { Dataset, FourDService } from '4d-mapper';
import { CoordGeodetic } from './coord-helper.service';
import { XsIdentityInterface } from '../xs/interfaces/identify.interface';



// some files are potentially there
export class VirtualDataset {

  // workflow states
  isLoading:boolean = false;
  isParsing:boolean = false;
  isProcessing:boolean = false;

  // sources
  static NONE:string = 'none';

  // the actual source
  source:string = VirtualDataset.NONE;

  // references to a Dataset
  datasetId:number = null;
  datasetName:string = null;
  dataset:Dataset = null;
  
  // our data
  raw:string = null;
  data:any = null;

  // most jobs deal with coordinates
  coords:CoordGeodetic[] = null;

  // lots of jobs have workflows and states with them
  workflow:any = null;
  states:any = null;
  show:any = null;

  // ... and current state
  state:any = null;

  constructor( incoming:any = null ) {
    if ( incoming ) {
      this._inject ( incoming );
    }
  }

  _inject ( incoming:any = {} ) {
    let me = this;
    Object.keys(incoming).forEach(key => {
      if ( me.hasOwnProperty ( key ) ) {
        me[key] = incoming[key];
      }
    });
  } 
}

@Injectable({
  providedIn: 'root'
})
export class FileManagementService implements XsIdentityInterface {

  __ID = null;

  debug:boolean = Constants.debug_off;
  debugMe:string = null;
  debugPrimary:string = Constants._green;
  debugSecondary:string = Constants._gray;


  static tokenDelimeter = ",";
  static isHeaderPresentFlag = true;
  static validateHeaderAndRecordLengthFlag = true;
  
  constructor(public snackBar: MatSnackBar, public fourD: FourDService ) {
    DEBUG.log ( '/service/file-management.service.ts' );
    this.__ID = XsIdentityInterface.__init(this);
  }


  findFiles ( inputFilesEvent = null, maxFiles = null ) {

    if ( inputFilesEvent && inputFilesEvent.srcElement ) {

      let files = inputFilesEvent.srcElement.files;

      if ( this.debug ) { console.log ( '%c fileManager %c findFiles()', this.debugPrimary, this.debugSecondary, inputFilesEvent, files ); }
  
      return files;
    }
 
  }

  readFileFromBrowser ( file:File = null ) {

    if ( !file ) {
      return;
    }

    var reader = new FileReader();

    reader.readAsText(file);

    reader.onload = (data) => {
      
    };
  }

  getAttachments( item:any ) {
    const me = this;
    return new Promise ( (resolve,error) => {

      let itemType = 'Annotation';

      if(item.id){
        me.fourD.V.api('/api/'+ itemType +'/' + item.id + '.files').subscribe( value => {
          resolve(value);
        });
      }

    });
    
  }

  // attachFile ( 'some_file_name', item, byteStream )

  attachFile ( filename:string = null, byteCharacters:any, item:any ) {

    const me = this;

    let itemType = 'Annotation';

    const token = this.fourD.V.token;
    const host = this.fourD.V.config.host;

    if ( !filename ) {
      let d = new Date();
      filename = 'file_'+d.getTime();
    }

    var xhr = new XMLHttpRequest();
    var upload = xhr.upload;
    upload.addEventListener('progress', (evt) => {
      if (evt.lengthComputable) {
        /* self.progress = ((self.loaded + evt.loaded) / self.total);
        self.progressSubject.next(self.progress)*/
        // console.log(evt);
        // this.loadExistingAnnotation( '' + this.annotation.id ) ;
      }
    }, false);

    return new Promise ( (resolve,error) => {

      xhr.open('POST', host + '/api/' + itemType + '/' + item.id + '/' + filename);
      xhr.overrideMimeType('application/octet-stream');
      xhr.setRequestHeader('Content-Type', 'application/octet-stream')
      xhr.setRequestHeader('Authorization', 'Bearer ' + token)
      xhr.send(byteCharacters);

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
  
          if (!xhr.responseText || xhr.responseText === '') {
            me.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
            return;
          }
          // good response
          var res = JSON.parse(xhr.responseText);
          if (res.status && res.status === 200) {
            {
              resolve(res);
              // me.snackBar.open(Constants.SUCCESS_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
              // this.openSnackBarSuccess(Constants.SUCCESS_MESSAGE);
              
            }
            // console.log('all good',res);
            // this.getAttachedFiles();
            // all good
          } else if (res.status && res.status < 400) {
            // console.log('vasat error');
            error(res)
            // me.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
          } else {
            error(res)
            // me.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
          }
        }
      };
    });
  }

















  /* Older code from various places; all of these are to be replaced over time */

  isCSVFile(file) {
    return file.name.endsWith(".csv");
  }

  getHeaderArray(csvRecordsArr, tokenDelimeter) {
    if(csvRecordsArr[0].endsWith(','))
      csvRecordsArr[0] = csvRecordsArr[0].substr(0,csvRecordsArr[0].length-1)
    let headers = csvRecordsArr[0].split(tokenDelimeter);
    if(!headers || headers.length <= 1){
      headers = csvRecordsArr[0].split('\t');
    }
    let headerArray = [];
    for (let j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }

  validateHeaders(origHeaders, fileHeaaders) {
    if (origHeaders.length != fileHeaaders.length) {
      return false;
    }

    var fileHeaderMatchFlag = true;
    for (let j = 0; j < origHeaders.length; j++) {
      if (origHeaders[j] != fileHeaaders[j]) {
        fileHeaderMatchFlag = false;
        break;
      }
    }
    return fileHeaderMatchFlag;
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray, headerLength,
        validateHeaderAndRecordLengthFlag, tokenDelimeter,DEFAULT_LATITUDE_ACCURACY, DEFAULT_LONGITUDE_ACCURACY, DEFAULT_HEIGHT_ACCURACY) {

    var dataArr = []

    for (let i = 0; i < csvRecordsArray.length; i++) {
      if(csvRecordsArray[i].endsWith(','))
        csvRecordsArray[i] = csvRecordsArray[i].substr(0,csvRecordsArray[i].length-1)
      let data = csvRecordsArray[i].split(tokenDelimeter);
      if(!data || data.length <= 1){
        data = csvRecordsArray[i].split('\t');
      }
      if(validateHeaderAndRecordLengthFlag && data.length != headerLength){
        if(data==""){
          // alert("Extra blank line is present at line number "+i+", please remove it.");
          continue;
        }else{
          this.snackBar.open("Record at line number "+i+" contain "+data.length+" tokens, and is not matching with header length of :"+headerLength, '',  {duration: Constants.SNACKBAR_DURATION});
          continue;
        }
      }

      let col = [];
      for (let j = 0; j < data.length; j++) {
        col.push(data[j].trim());
      }
      if(col.length !== 7){
        col.push(DEFAULT_LATITUDE_ACCURACY);
        col.push(DEFAULT_LONGITUDE_ACCURACY);
        col.push(DEFAULT_HEIGHT_ACCURACY);

      }
      dataArr.push(col);
    }
    return dataArr;
  }

}
